export default "<tc-reporting-list></tc-reporting-list>";